import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks"
import { ButtonComponent } from "../../ui/molecules/button/newButton"
import { MadfarmInput } from "../../ui/molecules/input/newInput"
import { MadfarmStaticSelect } from "../../ui/molecules/select/newSelect/static"
import { Pagination } from "../../ui/organisms/pagination"
import { CodexSampleStatusOptions, optionsFormatter } from "../../utils"
import { GetAllCodexSamples, resetGetAllCodexSampleFilters, setGetAllCodexSampleEnvelopNumber, setGetAllCodexSamplePage, setGetAllCodexSamplePersonalManagementId, setGetAllCodexSampleStatus } from "./slice"

enum FilteringTypologyEnum {
    INSPECTOR = 'INSPECTOR',
    NUMBER = 'NUMBER',
}

export function GestionePrelieviList() {
    const dispatch = useAppDispatch()
    const codexSampleState = useAppSelector(state => state.codexSample)
    const [filteringTypology, setFilteringTypology] = useState<FilteringTypologyEnum>(FilteringTypologyEnum.INSPECTOR)

    useEffect(() => {
        dispatch(GetAllCodexSamples(codexSampleState.getAllCodexSampleFilters))
    }, [codexSampleState.getAllCodexSampleFilters.page])

    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-wrap items-end gap-2">
                <div className="w-48">
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        placeholder="Seleziona tipo di filtro..."
                        options={[
                            { value: FilteringTypologyEnum.INSPECTOR, label: 'Tecnico Ispettore' },
                            { value: FilteringTypologyEnum.NUMBER, label: 'Numero Busta' },
                        ]}
                        value={filteringTypology}
                        onChange={(value) => {
                            //@ts-ignore
                            setFilteringTypology(value?.value as FilteringTypologyEnum)
                        }}
                        noOptionsMessage={""}
                    />
                </div>
                {filteringTypology === FilteringTypologyEnum.INSPECTOR && (
                    <>
                        <div className="flex-1 min-w-[200px]">
                            <MadfarmStaticSelect
                                menuPortalTargetIsNotBody
                                placeholder="Seleziona ispettore..."
                                options={codexSampleState.PMResources}
                                value={codexSampleState.getAllCodexSampleFilters.personalManagementId}
                                onChange={(value) => {
                                    //@ts-ignore
                                    dispatch(setGetAllCodexSamplePersonalManagementId(value?.value))
                                }}
                                noOptionsMessage={""}
                            />
                        </div>
                        <div className="flex-1 min-w-[200px]">
                            <MadfarmStaticSelect
                                menuPortalTargetIsNotBody
                                placeholder="Seleziona stato..."
                                options={CodexSampleStatusOptions}
                                value={codexSampleState.getAllCodexSampleFilters.status}
                                onChange={(value) => {
                                    //@ts-ignore
                                    dispatch(setGetAllCodexSampleStatus(value?.value))
                                }}
                                noOptionsMessage={""}
                            />
                        </div>
                    </>
                )}

                {filteringTypology === FilteringTypologyEnum.NUMBER && (
                    <div className="w-48">
                        <MadfarmInput
                            placeholder="Specifica n. busta..."
                            value={codexSampleState.getAllCodexSampleFilters.envelopNumber !== undefined
                                ? String(codexSampleState.getAllCodexSampleFilters.envelopNumber)
                                : undefined}
                            onChangeText={(text) => dispatch(setGetAllCodexSampleEnvelopNumber(text))}
                        />
                    </div>
                )}

                <ButtonComponent
                    size="lg"
                    iconPosition="off"
                    variant="outline"
                    label="Pulisci"
                    color="gray"
                    onClick={() => dispatch(resetGetAllCodexSampleFilters())}
                />
                <ButtonComponent
                    size="lg"
                    iconPosition="off"
                    variant="solid"
                    label="Cerca"
                    color="orange"
                    onClick={() => dispatch(GetAllCodexSamples(codexSampleState.getAllCodexSampleFilters))}
                />
            </div>
            <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                <table className="w-full border-collapse text-text-md min-w-[1000px]">
                    <thead>
                        <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl w-8"></th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Ispettore</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Numero Busta</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo Assegnazione</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Stato</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Incarico / Visita</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cliente</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Normativa</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tr-xl w-8"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {!codexSampleState.getAllCodexSampleResponse?.data?.length ? (
                            <tr>
                                <td colSpan={9} className="px-3 py-3 text-left text-neutral-500 bg-white">
                                    Nessun prelievo trovato
                                </td>
                            </tr>
                        ) : (
                            codexSampleState.getAllCodexSampleResponse.data.map((pre, index) => (
                                <tr
                                    key={index}
                                    className={`text-left border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                >
                                    <td className="px-3 py-2"></td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{pre.personalManagementInfo}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                        {`${Array(7 - String(pre.envelopNumber).length).fill('0').join('')}${pre.envelopNumber}`}
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{pre.entryProtocolInfo}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                        {optionsFormatter(pre.status, CodexSampleStatusOptions)}
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700">{`Incarico: TO FUTURE della Visita ispettiva del TO FUTURE`}</td>
                                    <td className="px-3 py-2 text-neutral-700">CLIENTE [DA FARE]</td>
                                    <td className="px-3 py-2 text-neutral-700">NORMATIVA [DA FARE]</td>
                                    <td className="px-3 py-2"></td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            <Pagination
                numbResults={codexSampleState.getAllCodexSampleResponse?.total || 0}
                pages={codexSampleState.getAllCodexSampleResponse?.totalPage || 1}
                currentPage={codexSampleState.getAllCodexSampleFilters.page || 0}
                setPage={(page) => dispatch(setGetAllCodexSamplePage(page))}
            />
        </div>
    )
}